/**
 * What a photo, a note or a share belongs to: a plant, or a location.
 *
 * A location has the same photos, notes and public page a plant has, kept in
 * their own tables and reached through their own routes. The pieces of the
 * plant card that handle those take a subject rather than a plant id, and
 * ask the matching route.
 *
 * No endpoints of its own: api/notes, api/photos and api/shares take a
 * Subject and pick the route. Who uses it: those, and the plant and bed
 * cards' photo, note and share dialogs in features/plant-list and
 * features/locations.
 *
 * @module subject
 */

/** A plant (by plant_obj_id) or a location (by its id). */
export type Subject = { kind: 'plant'; id: number } | { kind: 'location'; id: number };

/**
 * A plant as a subject.
 *
 * @param id - The plant's plant_obj_id.
 */
export const plantSubject = (id: number): Subject => ({ kind: 'plant', id });

/**
 * A location as a subject.
 *
 * @param id - The location's id.
 */
export const locationSubject = (id: number): Subject => ({ kind: 'location', id });

